import { render, staticRenderFns } from "./allInvoice.vue?vue&type=template&id=2a385fd6"
import script from "./allInvoice.vue?vue&type=script&lang=js"
export * from "./allInvoice.vue?vue&type=script&lang=js"
import style0 from "./allInvoice.vue?vue&type=style&index=0&id=2a385fd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports